import { lightenColor } from "@/utils/lightenColor";
import React from "react";

interface ShoppingBagIconAttributes {
  className?: string;
  brandingColor?: string;
}

export const ShoppingBagIcon: React.FC<ShoppingBagIconAttributes> = ({
  className = "",
  brandingColor = "#22880",
}: ShoppingBagIconAttributes) => {
  const lighterBrandingColor = lightenColor(brandingColor, 90);
  return (
    <svg
      width="72"
      height="69"
      viewBox="0 0 72 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.6494 24.2275H10.5057C8.51196 24.1512 6.76582 25.4717 6.42112 27.3166L0.732233 64.4679C0.672637 65.4994 1.08502 66.5058 1.8657 67.234C2.64638 67.9621 3.72111 68.3429 4.8197 68.2805H56.3354C57.4338 68.343 58.5083 67.9621 59.2885 67.2339C60.0688 66.5056 60.4805 65.4992 60.4201 64.4679L54.7312 27.3166C54.3866 25.4728 52.6421 24.1526 50.6494 24.2275Z"
        fill={`${lighterBrandingColor}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.0478 18.2204H16.9042C14.9104 18.1441 13.1643 19.4647 12.8196 21.3095L7.13067 58.4608C7.07107 59.4923 7.48345 60.4987 8.26414 61.2269C9.04482 61.9551 10.1195 62.3358 11.2181 62.2734H62.7339C63.8322 62.3359 64.9067 61.9551 65.687 61.2268C66.4672 60.4985 66.8789 59.4921 66.8185 58.4608L61.1296 21.3095C60.785 19.4657 59.0406 18.1455 57.0478 18.2204Z"
        fill="white"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4143 30.9475C29.0034 30.9475 29.481 31.3958 29.481 31.9487C29.481 32.5017 29.0034 32.9499 28.4143 32.9499C27.8252 32.9499 27.3477 32.5017 27.3477 31.9487C27.3477 31.3958 27.8252 30.9475 28.4143 30.9475"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.4807 30.9475C46.0698 30.9475 46.5474 31.3958 46.5474 31.9487C46.5474 32.5017 46.0698 32.9499 45.4807 32.9499C44.8916 32.9499 44.4141 32.5017 44.4141 31.9487C44.4141 31.3958 44.8916 30.9475 45.4807 30.9475"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.9112 44.2515C46.2382 48.0047 41.7458 50.258 36.936 50.258C32.1263 50.258 27.6339 48.0047 24.9609 44.2515"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4135 10.3627C46.4497 5.63771 42.0542 2.21605 36.9288 2.20093V2.20093C31.8301 2.22192 27.455 5.61582 26.4727 10.312"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
